module.exports = __webpack_public_path__ + "img/while_right.e1a5cb88.svg";